exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".MainContainer__MainContainer__m8WX0{\n    padding: 0 1rem;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: start;\n        align-items: flex-start;\n    height: 100%;\n}\n\n.MainContainer__loggedOut__b8Y1U{\n    margin: 0 !important;\n    padding: 0;\n}\n\n@media(min-width:768px){\n    .MainContainer__MainContainer__m8WX0 {\n        margin-left: 30%;\n    }\n}\n\n\n@media(min-width: 1024px){\n    .MainContainer__MainContainer__m8WX0 {\n        margin-left: 25%;\n    }\n}", ""]);

// exports
exports.locals = {
	"MainContainer": "MainContainer__MainContainer__m8WX0",
	"loggedOut": "MainContainer__loggedOut__b8Y1U"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/hoc/Layout/MainContainer/MainContainer.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/hoc/Layout/MainContainer/MainContainer.css
// module chunks = 0